module.exports = __webpack_public_path__ + "img/004-payment.d775aff4.svg";